module.exports = __webpack_public_path__ + "static/media/logout.6e8fac2e.svg";